/**
 * @generated SignedSource<<9f04308d2e21656795903351d4b2458c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useMeasurementUnit_user$data = {
  readonly preferences: {
    readonly measurementUnit: string | null;
  } | null;
  readonly " $fragmentType": "useMeasurementUnit_user";
};
export type useMeasurementUnit_user$key = {
  readonly " $data"?: useMeasurementUnit_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"useMeasurementUnit_user">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "useMeasurementUnit_user"
};

(node as any).hash = "5a9b382047f2c1f9f9a18a2da3d16a09";

export default node;
